import { render, staticRenderFns } from "./icn-close.vue?vue&type=template&id=308cbaea&scoped=true&"
import script from "./icn-close.vue?vue&type=script&lang=js&"
export * from "./icn-close.vue?vue&type=script&lang=js&"
import style0 from "./icn-close.vue?vue&type=style&index=0&id=308cbaea&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308cbaea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/welearn-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('308cbaea', component.options)
    } else {
      api.reload('308cbaea', component.options)
    }
    module.hot.accept("./icn-close.vue?vue&type=template&id=308cbaea&scoped=true&", function () {
      api.rerender('308cbaea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/svg/icn-close.vue"
export default component.exports